import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
import _defineProperty from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _merge from "lodash/merge";
import { reactive } from '@vue/composition-api';
import axios from '@/services/axios';
import { toLocaleString, toFixedWithOutRounding, storageData } from '@/common/util';
import { getKConfData, deserializationJSON } from '@/config/fish/index';
;
;
;
var LanguageStorage;

(function (LanguageStorage) {
  LanguageStorage["name"] = "LANGUAGE_DATA";
  LanguageStorage["time"] = "LANGUAGE_TIME";
})(LanguageStorage || (LanguageStorage = {}));

;
var MessagesStorage;

(function (MessagesStorage) {
  MessagesStorage["name"] = "MESSAGES_DATA";
  MessagesStorage["time"] = "MESSAGES_TIME";
})(MessagesStorage || (MessagesStorage = {}));

var inviteShareData = reactive({
  result: 0,
  landingBindAward: '0',
  landingTotalAward: '0',
  coinUnit: '',
  headUrl: '',
  nickName: '',
  inviteCode: '',
  sharePageType: 0
});

var fetchData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
    var res, _res$data, headUrl, nickName, inviteCode, currencySymbol, _res$data$landingBind, landingBindAward, _res$data$landingTota, landingTotalAward;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get('/rest/w/promotion/task/relation/getRelationLanding', {
              params: params
            });

          case 2:
            res = _context.sent;
            inviteShareData.result = res.result;

            if (inviteShareData.result === 1) {
              _res$data = res.data, headUrl = _res$data.headUrl, nickName = _res$data.nickName, inviteCode = _res$data.inviteCode, currencySymbol = _res$data.currencySymbol, _res$data$landingBind = _res$data.landingBindAward, landingBindAward = _res$data$landingBind === void 0 ? 0 : _res$data$landingBind, _res$data$landingTota = _res$data.landingTotalAward, landingTotalAward = _res$data$landingTota === void 0 ? 0 : _res$data$landingTota;
              inviteShareData.landingBindAward = toLocaleString(toFixedWithOutRounding(Number(landingBindAward) / 100, 2));
              inviteShareData.landingTotalAward = toLocaleString(toFixedWithOutRounding(Number(landingTotalAward) / 100, 2));
              inviteShareData.coinUnit = currencySymbol || '';
              inviteShareData.headUrl = String(headUrl).replace('http:', '') || '';
              inviteShareData.nickName = nickName || '';
              inviteShareData.inviteCode = inviteCode || '';
            }

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchData(_x) {
    return _ref.apply(this, arguments);
  };
}();

var reportShareTask = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(reportParams) {
    var formData;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            formData = new FormData();
            formData.append('reportType', reportParams.reportType);
            formData.append('data', reportParams.data);
            _context2.next = 5;
            return axios.post('/rest/w/promotion/task/share/report', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 5:
            return _context2.abrupt("return", _context2.sent);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function reportShareTask(_x2) {
    return _ref2.apply(this, arguments);
  };
}(); // 通过kconf获取落地页样式和素材


var getMessagesByCountry = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(options) {
    var _pages$find$langMessa, _pages$find;

    var settingsRedisTime, projectSettings, _storageData, data, isExpired, projectSettingsKey, projData, _projectSettings, countries, pages, currentCountry, defaultLanguage, langMessagesFileConf, langMessageFiles, redisTime, langMessages, _storageData2, messagesData, messagesIsExpired, kconfData, langMessageRequest, pageLangMessages;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            settingsRedisTime = 120;
            projectSettings = {};
            _storageData = storageData(LanguageStorage.name, "".concat(LanguageStorage.name, "_TIME"), settingsRedisTime), data = _storageData.data, isExpired = _storageData.isExpired;

            if (data) {
              projectSettings = deserializationJSON(data);
            } // 如果过期或数据为空，重新请求


            if (!(isExpired || !data || !projectSettings)) {
              _context3.next = 12;
              break;
            }

            projectSettingsKey = 'X6Frontend.kwai-pro-settings.encourage-project-settings';
            _context3.next = 8;
            return getKConfData([projectSettingsKey]);

          case 8:
            projData = _context3.sent;
            projectSettings = deserializationJSON(projData[projectSettingsKey]);
            window.localStorage.setItem(LanguageStorage.name, projData[projectSettingsKey]);
            window.localStorage.setItem("".concat(LanguageStorage.name, "_TIME"), new Date().getTime().toString());

          case 12:
            if (projectSettings) {
              _context3.next = 14;
              break;
            }

            return _context3.abrupt("return", {});

          case 14:
            _projectSettings = projectSettings, countries = _projectSettings.countries, pages = _projectSettings.pages; // 有可能为空

            currentCountry = countries.find(function (item) {
              return item.key === options.country;
            });

            if (currentCountry) {
              _context3.next = 18;
              break;
            }

            return _context3.abrupt("return", {});

          case 18:
            // 默认语言
            defaultLanguage = currentCountry.defaultLanguage;
            langMessagesFileConf = (_pages$find$langMessa = (_pages$find = pages.find(function (item) {
              return item.path === options.path;
            })) === null || _pages$find === void 0 ? void 0 : _pages$find.langMessages) !== null && _pages$find$langMessa !== void 0 ? _pages$find$langMessa : [];
            langMessageFiles = langMessagesFileConf.reduce(function (languageMessageFiles, item) {
              // 1. 兼容处理
              if (options.country === 'br') {
                languageMessageFiles.push("".concat(item.filePathPrefix, "-").concat(defaultLanguage));
              } // 2. 获取默认配置


              languageMessageFiles.push("".concat(item.filePathPrefix, "-").concat(options.country, "-").concat(defaultLanguage)); // 当前语言不为空 并且请求语言与当前桶默认语言不相同时 获取默认语言和请求语言的两个配置

              if (options.language && defaultLanguage !== options.language) {
                // 3. 获取不带地区码的语言配置
                if (options.language.includes('-')) {
                  var languageWithoutOrigin = options.language.split('-')[0];
                  languageMessageFiles.push("".concat(item.filePathPrefix, "-").concat(options.country, "-").concat(languageWithoutOrigin));
                }

                languageMessageFiles.push("".concat(item.filePathPrefix, "-").concat(options.country, "-").concat(options.language));
              }

              return languageMessageFiles;
            }, []);
            redisTime = 60;
            langMessages = {};
            _storageData2 = storageData("".concat(options.path, "_name"), "".concat(options.path, "_time"), redisTime), messagesData = _storageData2.data, messagesIsExpired = _storageData2.isExpired;

            if (messagesData) {
              langMessages = deserializationJSON(messagesData);
            } // 如果过期或数据为空，重新请求


            if (!(messagesIsExpired || !messagesData || !langMessages)) {
              _context3.next = 36;
              break;
            }

            _context3.next = 28;
            return getKConfData(langMessageFiles);

          case 28:
            kconfData = _context3.sent;
            langMessageRequest = langMessageFiles.map(function (item) {
              if (kconfData[item]) {
                return deserializationJSON(kconfData[item]);
              }
            });
            _context3.next = 32;
            return Promise.all(langMessageRequest);

          case 32:
            pageLangMessages = _context3.sent;
            langMessages = _merge.apply(void 0, _toConsumableArray(pageLangMessages));
            window.localStorage.setItem("".concat(options.path, "_name"), JSON.stringify(langMessages));
            window.localStorage.setItem("".concat(options.path, "_time"), new Date().getTime().toString());

          case 36:
            return _context3.abrupt("return", langMessages);

          case 37:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getMessagesByCountry(_x3) {
    return _ref3.apply(this, arguments);
  };
}(); // 通过后端接口获取落地页样式和素材


var getMessagesById = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params) {
    var messages, fishInfoRes, data, result, shareConfig, key, _data$content$h5Style, pageConfig, sharePageType, pageStyleMap;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            messages = {};
            _context4.prev = 1;
            _context4.next = 4;
            return new Promise(function (resolve, reject) {
              var url = "/rest/w/promotion/fish/getById";
              var requestHandler;

              if (window.initUrlPromise && window.initUrlPromise[location.origin + url] && window.initUrlPromise[location.origin + url] instanceof Promise) {
                requestHandler = window.initUrlPromise[location.origin + url];
                window.initUrlPromise[location.origin + url] = null;
              } else {
                requestHandler = axios.get('/rest/w/promotion/fish/getById', {
                  params: params
                });

                if (!window.initUrlHandler) {
                  window.initUrlHandler = {};
                }

                window.initUrlHandler[location.origin + url] = requestHandler;
              }

              ;
              requestHandler.then(function (result) {
                resolve(result);
              }).catch(function (error) {
                reject(error);
              });
            });

          case 4:
            fishInfoRes = _context4.sent;
            data = fishInfoRes.data, result = fishInfoRes.result;

            if (result === 1) {
              shareConfig = {};
              key = '';
              _data$content$h5Style = data.content.h5Style, pageConfig = _data$content$h5Style.pageConfig, sharePageType = _data$content$h5Style.sharePageType;
              inviteShareData.sharePageType = +sharePageType;
              shareConfig = pageConfig;
              pageStyleMap = {
                1: 'experiment-1',
                2: 'experiment-2'
              };

              if (sharePageType !== '0') {
                // 兜底snackvideo流量无sharePageType参数
                params.isSv && (inviteShareData.sharePageType = +sharePageType);
                key = pageStyleMap[sharePageType];
                shareConfig[key] = _objectSpread({}, pageConfig);
              }

              messages = _defineProperty({}, params.pageName || 'inviteShare', shareConfig);
            }

            _context4.next = 12;
            break;

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](1);
            console.log(_context4.t0);

          case 12:
            return _context4.abrupt("return", messages);

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 9]]);
  }));

  return function getMessagesById(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

export { inviteShareData, fetchData, getMessagesByCountry, getMessagesById, reportShareTask };